import axios from 'axios'
import Cookies from 'js-cookie'

import VueTabs from '@/js/components/vue-tabs.vue'
import VueTab from '@/js/components/vue-tab.vue'
import ProductItem from '@/js/components/product-item.js'
import KeenSlider from '@/js/components/keen-slider.vue'
import { productQuery, transformGraphqlProduct } from '@/js/utils/data'
import { storefrontRequestConfig, STOREFRONT_URL } from '@/js/utils/api'
import { getRecommendedProducts } from '@/js/utils/helpers'

export default {
  components: {
    ProductItem,
    KeenSlider,
    VueTabs,
    VueTab
  },

  props: {
    collectionHandle: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isLoading: true,
      firstProduct: null,
      recommendedProducts: [],
      imperfectProducts: [],
      perfectProducts: [],
      filteredProducts: [],
      collection: null,
      sliderOptions: {
        slides: {
          perView: 2.05,
          spacing: 4
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 16
            }
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 2.5,
              spacing: 8
            }
          },
          '(min-width: 1280px)': {
            slides: {
              perView: 4.075,
              spacing: 4
            }
          }
        }
      }
    }
  },

  async created () {
    this.collection = await this._getCollection(this.collectionHandle)
    this.firstProduct = this.collection?.products?.edges?.map(product => transformGraphqlProduct(product.node))?.pop()

    if (this.firstProduct) {
      this.recommendedProducts = await getRecommendedProducts(this.firstProduct.id).catch(error => {
        console.log(error)
      })

      this.filteredProducts = await this.filterProductsByState(this.recommendedProducts)
      this.imperfectProducts = this.filteredProducts?.filter((product) => product.tags.includes('badge:has_imperfections'))
      this.perfectProducts = this.filteredProducts?.filter((product) => product.tags.includes('badge:perfect_condition'))
    }

    this.isLoading = false
  },

  methods: {
    async _getCollection (handle) {
      const data = `{
        collectionByHandle(handle: "${handle}") {
          products (first: 1) {
            edges {
              node {
                ${productQuery}
              }
            }
          }
        }
      }`

      // eslint-disable-next-line no-undef
      return await axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
        return data.data.collectionByHandle
      }).catch((error) => {
        console.log('Get collection from similar products error:', error)
        throw error
      })
    },

    async filterProductsByState (products) {
      const currentState = Cookies.get('state') || 'NSW' // used to filter products based on the available inventory in a location
      const graphqlIds = products.map(product => `"gid://shopify/Product/${product.id}"`)
      const data = `{
        nodes(ids: [${graphqlIds}]) {
          id
          ... on Product {
            ${productQuery}
          }
        }
      }`

      return axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
        const products = data.data.nodes
        const filteredProducts = []

        products.forEach((product) => {
          let productItem = {}
          productItem = transformGraphqlProduct(product)

          // check if the current state value is ACT
          if (currentState === 'ACT') {
            // If the state is ACT, include products from both ACT and NSW warehouses
            if (productItem.available_on?.includes(currentState) || productItem.available_on?.includes('NSW')) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          } else {
            // check the state value (from the Cookie) and match if the selected state has an available inventory in the product
            if (productItem.available_on?.includes(currentState)) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          }
        })

        return filteredProducts
      }).catch((error) => {
        console.log('Similar products section error:', error)
        throw error
      })
    }
  }
}
